import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { urlReplace } from 'shared/modules';
import MainSliderImage from 'desktop/components/MainSliderImage/MainSliderImage';
import s from './FullScreenSlider.css';

class FullScreenSlider extends Component {
  static propTypes = {
    photos: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    id: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    // methods:
    setPrevId: PropTypes.func.isRequired,
    setNextId: PropTypes.func.isRequired,
    closeSlider: PropTypes.func.isRequired,
    setFullscreenImage: PropTypes.func.isRequired,
  };

  onSetPrevId = e => {
    e.stopPropagation();
    this.props.setPrevId();
  };

  onSetNextId = e => {
    e.stopPropagation();
    this.props.setNextId();
  };

  onCloseSlider = () => {
    this.props.closeSlider();
  };

  onSetFullscreenImage = e => {
    this.props.setFullscreenImage(e);
  };

  handleCloseSliderClick = e => {
    if (e.target.name === 'close') {
      this.props.closeSlider();
    }
  };

  render() {
    const { photos, id, left } = this.props;
    const sliderImage = photos && photos.find(photo => photo.id === id);

    return (
      <div name={'close'} className={s.fullscreenSlider} onClick={this.handleCloseSliderClick}>
        {photos.length > 1 &&
          <i className={`fa fa-angle-left ${s.sliderPrev}`} onClick={this.onSetPrevId} />}
        <MainSliderImage
          mainImage={sliderImage}
          sliderClassName={s.sliderMainImg}
          onClick={this.onSetNextId}
          appear={s.animAppear}
          appearActive={s.animAppearActive}
        />

        {photos.length > 1 &&
          <i className={`fa fa-angle-right ${s.sliderNext}`} onClick={this.onSetNextId} />}
        <i className={s.sliderClose} onClick={this.onCloseSlider} />

        <div name={'close'} className={s.sliderGalleryContainer}>
          <div
            className={s.sliderGallery}
            style={{ transform: `translateX(-${left}px)`, width: `${110 * photos.length}px` }}
          >
            {photos.length > 1 &&
              photos.map(photo =>
                <div
                  style={{
                    flex: `1 0 100px`,
                    height: `70px`,
                    margin: `10px 5px`,
                    maxWidth: '100px',
                  }}
                  className={cx({ [s.active]: id === photo.id }, s.sliderThumb)}
                  key={photo.id}
                >
                  <span
                    id={photo.id}
                    className={s.sliderImg}
                    onMouseOver={this.onSetFullscreenImage}
                    style={{
                      backgroundImage: `url(${urlReplace((photo && photo.image) || photo)})`,
                    }}
                  />
                </div>,
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(FullScreenSlider);



// WEBPACK FOOTER //
// ./src/desktop/components/FullScreenSlider/FullScreenSlider.js